import { render, staticRenderFns } from "./ThanksModal.vue?vue&type=template&id=4df2d3a0"
import script from "./ThanksModal.vue?vue&type=script&lang=js"
export * from "./ThanksModal.vue?vue&type=script&lang=js"
import style0 from "./ThanksModal.vue?vue&type=style&index=0&id=4df2d3a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports